var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 431.485,
    height: 295.099,
    viewBox: "0 0 431.485 295.099",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "water_mark",
    "data-name": "water mark",
    transform: "translate(14690.685 7284.226)",
    opacity: 0.038
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14776",
    "data-name": "Path 14776",
    d: "M315.644,177.111q-6.492-.078-12.537-.618a67.849,67.849,0,0,1-27.751-9.114c-8.524-5-14.747-11.923-21.023-19.411-3.6-4.292-7.29-8.845-11.477-12.583a33.135,33.135,0,0,0-8.943-5.841,12.887,12.887,0,0,0-1.463-.537l-31.524,30.523c-17.037-7.922-41.524-18.044-55.417-18.044-30.464,0-63.733,21.171-63.733,21.171s32-10.854,61.193-3.621c13.379,3.315,25.684,10.158,38.288,15.531,6.3,2.686,12.462,5.73,19,7.826,4.965,1.594,10.187,3.187,15.46,3,10.492-.38,18.092-8.907,27.075-14.864a92.061,92.061,0,0,0,10.513,4.907,96.967,96.967,0,0,0,19.35,5.329c8.914,1.543,17.828,2.627,26.81,1.034a67.736,67.736,0,0,0,16.18-4.688m-82.106-6.46c-10.455,1.652-21.156-5.72-30.173-9.976l14.56-13.916c21.509,12.038,15.612,23.892,15.612,23.892",
    transform: "translate(-14772.462 -7211.383)",
    fill: "#003e7f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2436",
    "data-name": "Rectangle 2436",
    width: 22.928,
    height: 22.928,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, -14624.923, -7092.95)",
    fill: "#003e7f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2437",
    "data-name": "Rectangle 2437",
    width: 22.928,
    height: 22.928,
    transform: "translate(-14657.35 -7092.95) rotate(-45)",
    fill: "#003e7f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2438",
    "data-name": "Rectangle 2438",
    width: 22.928,
    height: 22.928,
    transform: "translate(-14443.492 -7092.95) rotate(-45)",
    fill: "#003e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14777",
    "data-name": "Path 14777",
    d: "M278.313,128.09,250.3,155.26l2.01,1.846,9.942-9a172.484,172.484,0,0,0,42.021,25.846c18.39,7.883,34.818,10.45,48.665,10.3,37.137.172,61.31-17.241,61.31-17.241-88.989,25.244-135.941-38.913-135.941-38.913",
    transform: "translate(-14677.306 -7211.901)",
    fill: "#003e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14778",
    "data-name": "Path 14778",
    d: "M367.107,83.576c5.183-2.55,7.357-4.348,12.417-6.406V55.389s-14.675,4.06-29.439,17.7l-.006.006c-.1.091-.2.181-.31.272l-.008.008q-1.206,1.075-2.437,2.255l-.288.275c-11.059,10.716-23.23,28.085-28.4,54.989a28.544,28.544,0,0,0,1.623-2.439c1.717-2.644,3.483-5.257,5.353-7.8,13.377-18.158,35.1-33.937,41.5-37.087",
    transform: "translate(-14638.724 -7252.95)",
    fill: "#8f511f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14779",
    "data-name": "Path 14779",
    d: "M376.584,33.19C358.761,42.257,334.223,54.7,310.52,66.906c0,6.34-.008,12.66-.008,18.521q5.217-2.819,10.391-5.7c2.083-1.163,4.2-2.275,6.257-3.489,5.5-3.251,10.2-6.022,13.666-8.055A96.4,96.4,0,0,0,329.7,86.689c-2.987,6.582-6.337,13.9-6.481,21.267.6-.742,1.092-1.623,1.621-2.438,1.718-2.644,3.483-5.257,5.353-7.8,13.378-18.158,35.095-33.937,41.5-37.088,5.184-2.549,7.356-4.347,12.417-6.406V29.716c-1.466.688-4.592,1.981-7.526,3.473",
    transform: "translate(-14643.312 -7267.447)",
    fill: "#8f511f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14780",
    "data-name": "Path 14780",
    d: "M318.212,68.005c-7.23,3.813-13.888,7.373-19.663,10.527-5.276,2.881-9.82,5.426-13.378,7.515-45.179,26.532-57.016,66.587-57.016,66.587q1.232-1.927,2.408-3.65c3.005-4.123,9.07-11.319,19.484-19.373a.276.276,0,0,0,.03-.024q1.84-1.422,3.861-2.874c7-5.177,21.708-15.919,29.612-20.619,4.946-2.94,9.959-5.781,15-8.587q9.761-5.433,19.663-10.658,7.658-4.06,15.337-8.088V59.974c-5.307,2.762-10.452,5.454-15.337,8.031",
    transform: "translate(-14689.813 -7250.36)",
    fill: "#8f511f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14781",
    "data-name": "Path 14781",
    d: "M292.554,172.569h0l-.03-.012q-1.812-.732-3.53-1.535a208.013,208.013,0,0,1-31.778-18.1c-3.419-2.259-6.5-4.548-9.253-6.778l-.078-.061-.008-.008c-11.791-9.568-17.471-17.984-17.471-17.984L202.4,155.261l2.011,1.845,9.94-9a187.307,187.307,0,0,0,36.416,23.307,97.679,97.679,0,0,0,9.795,4.508,106.549,106.549,0,0,0,16.8,5.162v0l.014,0q1.333.288,2.676.543a91.275,91.275,0,0,0,10.724,1.367c22.572,1.778,32.13-5.4,32.13-5.4q-6.492-.077-12.539-.618a63.056,63.056,0,0,1-17.806-4.4",
    transform: "translate(-14704.354 -7211.901)",
    fill: "#003e7f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2439",
    "data-name": "Rectangle 2439",
    width: 22.928,
    height: 22.928,
    transform: "translate(-14443.492 -7005.339) rotate(-45)",
    fill: "#003e7f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2440",
    "data-name": "Rectangle 2440",
    width: 22.928,
    height: 22.928,
    transform: "translate(-14475.913 -7005.339) rotate(-45)",
    fill: "#003e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14782",
    "data-name": "Path 14782",
    d: "M329.914,217.024q-2.575-2.251-4.811-4.534c-.1-.1-.172-.2-.266-.3-.255-.269-.484-.551-.726-.826-2.83-3.452-3.541-8.449-3.674-11.414V164.89c.022-.369.034-.566.034-.566-.014-.679-.025-1.729-.034-3.09V97h-.05v-.879c0-5.863,0-12.181.008-18.521.02-24.358.077-49,.077-49s.006-.4-.034-1.037V10.771L309.548,23.2l-6.656,7.6-.25.286,0,0c-5.634,6.614-13.03,15.1-13.03,15.1l1.466,1.914,6.376-6.5s3.314-1.158,3.314,3.309V191.882s.258,6.628,4.686,10.8l-.075-.027s14.6,13.027,24.531,14.365",
    transform: "translate(-14655.111 -7278.143)",
    fill: "#003e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14783",
    "data-name": "Path 14783",
    d: "M277.172,110.47c5.775-3.154,12.434-6.712,19.663-10.527V86.232h-.05c0-28.447.085-68.4.085-68.4s.006-.4-.034-1.037V0L285.947,12.431l-6.656,7.6-.249.285,0,0c-5.633,6.615-13.029,15.105-13.029,15.105l1.466,1.912,6.374-6.5s3.315-1.159,3.315,3.308Z",
    transform: "translate(-14668.437 -7284.226)",
    fill: "#003e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14784",
    "data-name": "Path 14784",
    d: "M302.288,165.846q-2.575-2.251-4.811-4.534c-.1-.1-.172-.2-.266-.3-.255-.269-.484-.551-.726-.826-2.83-3.452-3.541-8.449-3.674-11.414V113.712c.022-.369.034-.566.034-.566-.014-.679-.025-1.729-.034-3.09V78.381q-9.89,5.241-19.664,10.658V140.7s.258,6.628,4.686,10.8l-.075-.027s14.6,13.027,24.531,14.365",
    transform: "translate(-14664.407 -7239.968)",
    fill: "#003e7f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlLogo);
export default __webpack_public_path__ + "static/media/al-logo.b8e67d951433f7bb085d96131e0386f1.svg";
export { ForwardRef as ReactComponent };